// Écrire à l'éditeur sans quitter l'application.
//
// POURQUOI CE COMPOSANT EXISTE
//
// Les pages des modules non souscrits disent « pour l'activer, contactez
// Ridelle » — et ne donnaient aucun moyen de le faire. C'est l'autre bout de
// cette page.
//
// L'ACCUSÉ DE RÉCEPTION SE MÉRITE, IL NE SE SUPPOSE PAS
//
// Le serveur ne répond qu'après l'acceptation du message par le service
// d'envoi. Un formulaire qui affiche « message envoyé » sans le savoir fait
// ressaisir l'utilisateur — ou pire, lui laisse croire qu'on l'ignore. Sur
// échec, on affiche l'erreur et **on garde le texte saisi** : le faire
// disparaître serait la deuxième punition.
//
// CE QU'ON N'ENVOIE PAS
//
// Ni adresse de destinataire, ni identité d'auteur : le serveur les tient du
// jeton et de sa configuration. Les mettre ici en ferait des valeurs choisies
// par le navigateur — donc falsifiables.
import { useState } from "react";

import api from "../api";

const SUJETS = [
  { valeur: "activation_module", label: "Activer un module" },
  { valeur: "question", label: "Poser une question" },
  { valeur: "probleme", label: "Signaler un problème" },
  { valeur: "autre", label: "Autre" },
];

const MIN = 10;
const MAX = 2000;

function messageErreur(err, defaut) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  return defaut;
}

export default function NousContacter({ module, sujetInitial, onFermer }) {
  const [sujet, setSujet] = useState(
    sujetInitial || (module ? "activation_module" : "question")
  );
  const [message, setMessage] = useState("");
  const [erreur, setErreur] = useState("");
  const [envoye, setEnvoye] = useState("");
  const [enCours, setEnCours] = useState(false);

  const envoyer = (e) => {
    e.preventDefault();
    setEnCours(true);
    setErreur("");
    api
      .post("/nous-contacter", {
        sujet,
        message,
        module: module || null,
        // L'écran d'origine, pour nous éviter trois allers-retours. C'est du
        // contexte, pas de l'identité.
        ecran: window.location.pathname,
      })
      .then(({ data }) => setEnvoye(data.message))
      .catch((err) =>
        setErreur(
          messageErreur(err, "Votre message n'a pas pu être envoyé. Réessayez.")
        )
      )
      .finally(() => setEnCours(false));
  };

  return (
    <div className="modal-overlay" onClick={onFermer}>
      <div className="modal-carte" onClick={(e) => e.stopPropagation()}>
        <h3 className="modal-titre">Nous contacter</h3>

        {envoye ? (
          <>
            {/* L'accusé de réception vient du SERVEUR, mot pour mot : il n'est
                affiché que si le message est réellement parti. */}
            <p className="note-info">{envoye}</p>
            <div className="modal-actions">
              <button className="btn-accent" onClick={onFermer}>
                Fermer
              </button>
            </div>
          </>
        ) : (
          <form className="formulaire" onSubmit={envoyer}>
            <p className="modal-sous-titre">
              Votre message nous arrive avec le nom de votre entreprise et
              votre adresse — inutile de les rappeler.
            </p>

            {erreur && <p className="erreur">{erreur}</p>}

            <label className="champ champ-large">
              <span className="champ-label">Objet</span>
              <select value={sujet} onChange={(e) => setSujet(e.target.value)}>
                {SUJETS.map((s) => (
                  <option key={s.valeur} value={s.valeur}>
                    {s.label}
                  </option>
                ))}
              </select>
            </label>

            <label className="champ champ-large">
              <span className="champ-label">Votre message *</span>
              <textarea
                required
                rows={7}
                minLength={MIN}
                maxLength={MAX}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder={
                  module
                    ? "Bonjour, nous souhaitons activer ce module…"
                    : "Bonjour, …"
                }
              />
            </label>
            <p className="sous-info">
              {message.length}/{MAX} caractères. N’indiquez jamais de mot de
              passe dans un message.
            </p>

            <div className="actions-form">
              <button type="button" className="btn" onClick={onFermer}>
                Annuler
              </button>
              <button
                className="btn-accent"
                type="submit"
                disabled={enCours || message.trim().length < MIN}
              >
                {enCours ? "Envoi…" : "Envoyer"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
